import CookieConsentBanner from 'react-cookie-consent';
import { initializeAnalytics } from '../utils/analytics';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

const CookieConsent = () => {
  const handleAccept = () => {
    // Initialize Google Analytics when user accepts
    if (GA_MEASUREMENT_ID) {
      initializeAnalytics(GA_MEASUREMENT_ID);
    }
  };

  return (
    <CookieConsentBanner
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      cookieName="biolean_cookie_consent"
      style={{
        background: '#1a1a1a',
        padding: '20px',
        alignItems: 'center',
        fontSize: '14px',
        fontFamily: 'Raleway, sans-serif',
      }}
      buttonStyle={{
        background: '#4CAF50',
        color: '#fff',
        fontSize: '14px',
        padding: '10px 30px',
        borderRadius: '4px',
        fontWeight: '600',
        border: 'none',
        cursor: 'pointer',
      }}
      declineButtonStyle={{
        background: 'transparent',
        border: '2px solid #fff',
        color: '#fff',
        fontSize: '14px',
        padding: '8px 30px',
        borderRadius: '4px',
        marginRight: '15px',
        fontWeight: '600',
        cursor: 'pointer',
      }}
      expires={365}
      enableDeclineButton
      onAccept={handleAccept}
    >
      We use cookies and other tracking technologies to improve your browsing
      experience on our website, to analyze our website traffic, and to understand
      where our visitors are coming from.{' '}
      <a
        href="/cookie-policy"
        style={{ color: '#4CAF50', textDecoration: 'underline' }}
      >
        Learn more
      </a>
    </CookieConsentBanner>
  );
};

export default CookieConsent;
